import { EvaluationEvidence } from '../interfaces/Organization';

export class MEvaluationEvidence{
    public id: number = null;
    public url: string = null;
    public name:string = null
    public description: string = null;

    constructor(evidence: EvaluationEvidence){
        this.id = evidence.id;
        this.url = evidence.url;
        this.name = evidence.nombre
        this.description = evidence.descripcion
    }
}